import { startTransition } from 'react';
import { proxyMap } from 'valtio/utils';
import type { NotificationType } from '#ui/constants';
import type { LinkButtonProps } from '../../Button/LinkButton';

export type ToastNotificationProps = {
  key?: string;
  link?: LinkButtonProps;
  headline: string;
  message?: string;
  date?: string;
  type: NotificationType;
  size?: 'short' | 'long';
  closable?: boolean;
  autoDismiss?: boolean;
};

export const state = proxyMap<
  string,
  ToastNotificationProps & { status: ToastNotificationProps['type'] }
>();

export function showToast(toast: ToastNotificationProps): void {
  startTransition(() => {
    state.set(toast.key || String(Date.now()), {
      ...toast,
      status: toast.type,
    });
  });
}

export function removeToast(key: string): void {
  state.delete(key);
}

export function clearToasts(): void {
  state.clear();
}
